import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { Redirect } from 'react-router-dom'



function withPredicate({
    predicate,   
    resolvingPredicate, 
    redirectPath,
    FailureComponent,
    ResolvingComponent
}) {
    const [     
        redirectValid, 
        failureComponentValid 
    ] = [ isRedirectValid(redirectPath), isFailureComponentValid(FailureComponent) ]

    if (!redirectValid && !failureComponentValid) {
        throw new Error("Provide redirect path (string) or failure component (function/Component) to your auth wrappers");
    }

    return (WrappedComponent) => {  
        const redirectFunc = getRedirectFunction(redirectPath);
        const auth = withCheck(WrappedComponent, redirectFunc, FailureComponent, ResolvingComponent);
        return inject((stores, props) => ({
            isAllowed: predicate(stores, props) || false,
            isResolving: isSome(resolvingPredicate) ? resolvingPredicate(stores, props) : false
        }))(observer(auth))
    }
}

function withCheck(WrappedComponent, redirectFunc, FailureComponent, ResolvingComponent) {    
    return function ComponentCheck({ isAllowed, isResolving }) {
        if (isResolving && isSome(ResolvingComponent)) {
            return <ResolvingComponent {...this.props} />
        }
        if (isAllowed) {
            return <WrappedComponent {...this.props} />                    
        } else if (isSome(redirectFunc)) {
            return redirectFunc(this.props.location);          
        } else  {
            return <FailureComponent {...this.props}  />
        }
    }
}

function isRedirectValid(redirect) {
    const redirectType = typeof redirect;
    return isSome(redirect) && (redirectType === 'string' || redirectType === 'function');
}

function isFailureComponentValid(failureComponent) {
    return isSome(failureComponent) &&  (typeof failureComponent === 'function');
}

function getRedirectFunction(redirectPath) {
    if (isRedirectValid(redirectPath)) {
        const redirectType = typeof redirectPath;
        if (redirectType === 'function') {
            return (location) => {
                return <Redirect to={{
                    pathname: redirectPath(location),
                    state: { from: location }
                  }}/>  
            }
        } else {
            return (location) => {
                return <Redirect to={{
                    pathname: redirectPath,
                    state: { from: location }
                  }}/>  
            };
        }
    }

    return null;
}

function isSome(obj) {
    return obj !== null && obj !== undefined;
}

export { withPredicate }


// WEBPACK FOOTER //
// ./src/routing/authComponent.js